import './instrument'
import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'
import './styles/colors_and_type.css'
import './styles/app.css'
import { App } from './App'
import { logEnv } from './config/env'

logEnv() // banner: ambiente/base ativos
createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={<p>Algo deu errado. Recarregue a página.</p>}>
    <App />
  </Sentry.ErrorBoundary>,
)
